<div class="basin-mobile-steps-title">
  Step {{ stepsActiveIndex + 1 }}&nbsp;-&nbsp;
  <span class="basin-mobile-steps-secondary-title">{{
    stepItems[stepsActiveIndex]?.label ?? ''
  }}</span>
</div>
<div
  [ngClass]="{ 'p-steps p-component': true, 'p-readonly': readonly }"
  [ngStyle]="style"
  [class]="styleClass"
>
  <ul role="tablist">
    <li
      *ngFor="let item of stepItems; let i = index"
      class="p-steps-item"
      #menuitem
      [ngStyle]="item.style"
      [class]="item.styleClass"
      role="tab"
      [attr.aria-selected]="i === stepsActiveIndex"
      [attr.aria-expanded]="i === stepsActiveIndex"
      pTooltip
      [tooltipOptions]="item.tooltipOptions"
      [ngClass]="{
        'p-highlight p-steps-current': isActive(item, i),
        'step-incomplete':
          stepsTracker &&
          stepsTracker[i].stepStarted &&
          !stepsTracker[i].stepCompleted,
        'step-complete':
          stepsTracker &&
          stepsTracker[i].stepStarted &&
          stepsTracker[i].stepCompleted,
        'p-disabled': item.disabled || (readonly && !isActive(item, i))
      }"
    >
      <a
        *ngIf="isClickableRouterLink(item); else elseBlock"
        [routerLink]="item.routerLink"
        [queryParams]="item.queryParams"
        role="presentation"
        [routerLinkActive]="'p-menuitem-link-active'"
        [routerLinkActiveOptions]="
          item.routerLinkActiveOptions || { exact: false }
        "
        class="p-menuitem-link"
        (click)="itemClick($event, item, i)"
        (keydown.enter)="itemClick($event, item, i)"
        [target]="item.target"
        [attr.id]="item.id"
        [attr.tabindex]="
          item.disabled || readonly ? null : item.tabindex ? item.tabindex : '0'
        "
        [fragment]="item.fragment"
        [queryParamsHandling]="item.queryParamsHandling"
        [preserveFragment]="item.preserveFragment"
        [skipLocationChange]="item.skipLocationChange"
        [replaceUrl]="item.replaceUrl"
        [state]="item.state"
      >
        <span class="p-steps-number">{{ i + 1 }}</span>
        <div
          *ngIf="item.icon"
          [class]="item.icon + ' basin-stepper-icon'"
        ></div>
        <span
          class="p-steps-title"
          *ngIf="item.escape !== false; else htmlLabel"
          >{{ item.label }}</span
        >
        <ng-template #htmlLabel
          ><span class="p-steps-title" [innerHTML]="item.label"></span
        ></ng-template>
      </a>
      <ng-template #elseBlock>
        <a
          [attr.href]="item.url"
          class="p-menuitem-link"
          role="presentation"
          (click)="itemClick($event, item, i)"
          (keydown.enter)="itemClick($event, item, i)"
          [target]="item.target"
          [attr.id]="item.id"
          [attr.tabindex]="
            item.disabled || (i !== stepsActiveIndex && readonly)
              ? null
              : item.tabindex
              ? item.tabindex
              : '0'
          "
        >
          <span class="p-steps-number" [class.content-none]="item.icon"
            ><div *ngIf="!item.icon">{{ i + 1 }}</div>
            <div
              *ngIf="item.icon && stepsActiveIndex !== i"
              [class]="item.icon + ' basin-stepper-icon'"
            ></div
          ></span>

          <span
            class="p-steps-title"
            *ngIf="item.escape !== false; else htmlRouteLabel"
            >{{ item.label }}</span
          >
          <ng-template #htmlRouteLabel
            ><span class="p-steps-title" [innerHTML]="item.label"></span
          ></ng-template>
        </a>
      </ng-template>
    </li>
  </ul>
</div>
